import React, { Component } from 'react';
import { translate } from 'react-i18next';

import './IndexContent.css';

class IndexContent extends Component {

  componentDidMount() {
    this.loadInternalLinks();
  }

  componentWillReceiveProps() {
    setTimeout(this.loadInternalLinks, 1000);
  }

  loadInternalLinks = () => {
    const { data, goToNode } = this.props;
    const links = document.querySelectorAll(`#${data.id} div.ic-content a[data-link]`);
    links.forEach((l) => {
      const goTo = l.getAttribute('data-link');
      l.addEventListener('click', () => {
        goToNode(goTo);
      });
    });
  }

  render() {
    const { data } = this.props;
    return (
      <div id={data.id} className='index-content-container'>
        <p className='ic-title'>{data.title}</p>
        <p className='ic-subtitle'>{data.subtitle}</p>
        <div className='ic-content' dangerouslySetInnerHTML={{ __html: data.content }} ></div>
      </div>
    );
  }
}

export default translate()(IndexContent);
